import React, { useContext, useEffect, useState } from 'react';
import Table from './table/table'
import AcceptLabelConversionsButton from './table/acceptLabelConversionsButton';
import { SourceViewToggle, isSourceViewAvailable } from '../../../../../components/sourceView';
import { DUPLICATED_REPORTS_MSG, ReportsUtils } from '../../../../../utils/reportsUtils'
import ReportsRepo from '../../../../../utils/repository/repoertsRepo';
import Loader from '../../../../../components/loader';
import { PasteMode } from './table/pasteMode';
import { Descriptor } from '../../../../../models/descriptorModel';
import { Button, Checkbox, Form, Grid, Icon, Label, Segment } from 'semantic-ui-react';
import FilterAndSortCfg from '../../../../../components/financialTables/configuration/filterAndSortConfig';
import { applyFilterCfg } from '../../../../../components/financialTables/configuration/applyUtill';
import UserPreferences from '../../../../../service/userPreferences';
import Utils from '../../../../../utils/descriptor/descriptorUtils';
import BatchUpdateModal from './table/batchUpdateModal';
import SyncWithResurcesModal from './syncWithResourcesModal'
import { getAvalableTargetReports } from './table/utils/copyReportDataUtils'
import { ConfigProps, PropValues, ReviewType, SETTINGS_PROFILE } from '../../../../../components/financialTables/configuration/constants';
import Alert from '../../../../../utils/alert';
import { serverToLocalDate } from '../../../../../utils/dateTimeUtils';
import { ReportField } from '../../../../../constnats/reportConstants';
import UserRepo from '../../../../../utils/repository/userRepo';
import { ROLES } from '../../../../../constnats/user';
import TableAndP2pConfig from '../../../../../components/financialTables/configuration/tableAndP2pConfig';
import TableChart from '../../../../../components/tableChart';
import hash from "object-hash"
import { DescriptorProps } from '../../../../../constnats/descriptor';
import DescriptorType from '../../../../../utils/descriptor/descriptorType';
import { BranchTypes, SchemaNames } from '../../../../../constnats/schemaConstants';
import ImportDataFromImageModal from './importDataFromImageModal';
import ImportsRepo from '../../../../../utils/repository/importsRepo';
import { Link, useLocation } from 'react-router-dom';
import TableActionButton from '../../../../../components/buttons/tableActionButton';
import RouteC from '../../../../../constnats/routeConstants';
import Legend from './legend';
import AuthService from '../../../../../service/auth';
import { BranchSettingContext } from '../../../../../contexts/branchSettingsContext';
import FilterAndSortCfgV2 from '../../../../../components/financialTables/configuration/filterAndSortConfigV2';
import TableAndP2pConfigV2 from '../../../../../components/financialTables/configuration/tableAndP2pConfigV2';
import { CheckboxBtn, SelectField, SelectFieldWrapper } from '../../../../../components/financialTables/configuration/fields';
import KeyValue from '../../../../../structures/keyValePair';
import StandardizedLabelsRepo from '../../../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import { RESPONSE_STATUS } from '../../../../../constnats/general';
import { flipReportsFieldValue, getReportsChanges, getReportsChangesTableModel, getReportsEntries } from './signFlipUtils';
import ReportsChangesConfirmationModal from './ReportsChangesConfirmationModal';
import ReportUtils from '../../../../../utils/reportUtils';
import ReportedAsLabelWarning from './components/reportedAsLabelWarning';

function systemFieldDescriptors() {
    const parentDescriptor = new Descriptor("system-fields-separator-parent",
        "System Fields", null, false, {}, false,
        DescriptorType.HEADLINE, false)

    const systemFieldDescriptors = [
        new Descriptor("system-fields-separator", "",
            null, false, { backgroundColor: "#c2c2c2" }, false, DescriptorType.HEADLINE, false),
        parentDescriptor
    ]

    const subFields = [
        new Descriptor("id", "ID",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.OWNER_NAME, "Owner",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.FULL_CHECKS_COUNT, "Full Checks",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.CD_CHECKS_COUNT, "CD Checks",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.VISUAL_CHECKS_COUNT, "Visual Checks",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.CREATED_ON_DATE_ONLY, "Created On",
            null, false, {}, false, DescriptorType.ANY, false),
        new Descriptor(ReportField.UPDATED_ON_DATE_ONLY, "Updated On",
            null, false, {}, false, DescriptorType.ANY, false)
    ]

    parentDescriptor.subFields = subFields

    return systemFieldDescriptors
}


class EmployeesProvider {

    static employees = null

    static getAll() {
        return new Promise(resolve => {
            if (EmployeesProvider.employees === null) {
                UserRepo.list({ userRoles: [ROLES.EMPLOYEE], includeDisabled: true },
                    users => {
                        EmployeesProvider.employees = users
                        resolve(users)

                    })
            } else {
                return resolve(EmployeesProvider.employees);
            }
        })
    }
}

async function getNormalizedReports(reports) {
    const reportsCopy = JSON.parse(JSON.stringify(reports))
    const users = await EmployeesProvider.getAll()

    const nonNullFields = [
        ReportField.OWNER_ID,
        ReportField.FULL_CHECKS_COUNT,
        ReportField.VISUAL_CHECKS_COUNT,
        ReportField.CD_CHECKS_COUNT,
    ]
    for (const report of reportsCopy) {
        for (const field of nonNullFields) {
            if (report[field] === null) {
                report[field] = ""
            }
        }

        report[ReportField.CREATED_ON_DATE_ONLY] = serverToLocalDate(report[ReportField.CREATED_ON])
        report[ReportField.UPDATED_ON_DATE_ONLY] = serverToLocalDate(report[ReportField.UPDATED_ON])

        if (report[ReportField.OWNER_ID] !== "") {
            report[ReportField.OWNER_NAME] = users.find(u => u.id === report[ReportField.OWNER_ID])?.fullName
        }

    }

    return reportsCopy
}

/**
 * TODO: Users should not be able to create multiple imports
 * if an import already exits the button should be disabled or hidden
 */
function ImportFromImageButton({ onClick, schema }) {
    const branchSettings = useContext(BranchSettingContext)

    if (!branchSettings.isAutoImportSupported) {
        return null
    }

    return (
        <Button size='mini' onClick={onClick}>
            Import From Image
        </Button>
    )
}

function ActiveImport({ importId }) {
    return (
        <div className='imports-container'>
            <Label>Active Import:  <Link to={`${RouteC.TABLE_EXTRACTION}${importId}`}>{importId}</Link></Label>
        </div>
    )
}

function ActiveImports({ schemaId }) {
    const [importIds, setImportIds] = useState([])

    useEffect(() => {
        ImportsRepo.getActiveBySchema(schemaId, (resp) => {
            if(resp.status === "SUCCESS") {
                setImportIds(resp.data)
            }else {
                Alert.error(resp.message)
            }
        })
    }, [schemaId])


    return (
        !!importIds.length && <Segment size='mini'>
            {importIds.map(importId => {
                return <ActiveImport key={importId} importId={importId} />
            })}
        </Segment>
    )
}

class Reports extends React.Component {

    constructor(props) {
        super(props)
        this.reloadReports = this.reloadReports.bind(this)

        this.descriptors = JSON.parse(JSON.stringify(this.props.schema.descriptors))

        Utils.forEach(this.descriptors, descriptor => {
            if (descriptor[DescriptorProps.IMPORTANCE] === 10) {
                descriptor[DescriptorProps.STYLE] = {
                    ...descriptor[DescriptorProps.STYLE],
                    backgroundColor: "rgb(194, 194, 194)"
                }
            }
        })

        if (!this.props.readOnly) {
            this.descriptors.unshift(
                new Descriptor(DescriptorProps.INPUT_SCALE, "Primary Input Scale",
                    null, false, {}, false, DescriptorType.ANY, false))

        } else {
            this.descriptors.push(...systemFieldDescriptors())
        }


        this.flatDescriptors = Utils.flatDescriptors(this.descriptors)
        this.dynamicFlatDescriptors = this.flatDescriptors
            .filter(d => d[DescriptorProps.DYNAMIC] === true)
        this.reportsUtil = new ReportsUtils(this.dynamicFlatDescriptors)


        this.state = {
            reports: [],
            filterCfg: {...UserPreferences.get(UserPreferences.FILTER_CFG_PROP),
                [ConfigProps.ORIGINAL_VERSION_CONDITIONAL_FILTER]: ConfigProps.CONDITIONAL_ORIGINAL_DISABLED
            },
            /**
             * in the client view part of the app this is named table config but
             * both cases(here and in client view) serve the same purpose
             */
            advancedTableCfg: UserPreferences.get(UserPreferences.TABLE_CFG_PROP),
            loading: true,
            showFieldsSettings: false,
            syncReportsModal: null,
            profile: UserPreferences.getPreferredProfile(),
            standardizedLabels: [],
            /**
             * Provenance is a large payload only Source view needs, so reports load without it and
             * are re-fetched with it the first time a user opens Source view. Sticky from then on,
             * so every later reload keeps it and toggling Source view off and on again is free.
             */
            provenanceRequested: false,
            provenanceLoading: false,
            sourceViewEnabled: false,
        }

        this.calculatedReports = []
    }

    componentDidMount() {
        this.reloadReports()
        StandardizedLabelsRepo.listStandardizedLabels(response => {
            if(response.status === RESPONSE_STATUS.SUCCESS) {
                this.setState({standardizedLabels: response.data})
            }
        })
    }
    /**
     * @param {Object} [additionalState] Optional An object that contains pieces of state
     * example:
     * { advancedTableCfg: {contains the new advanced table config settings} }
     */
    reloadReports(additionalState) {
        const enableAsserts = this.props.schema.branchType === BranchTypes.MAIN;
        ReportsRepo.listBySchema(this.props.schema.id, async reports => {
            reports = await getNormalizedReports(reports)
            this.calculatedReports = this.reportsUtil.getCalculatedReports(reports,
                (a, b) => {
                    Alert.warn(DUPLICATED_REPORTS_MSG);
                    return a
                }, enableAsserts)
            this.setState({
                reports: reports,
                loading: false,
                provenanceLoading: false,
                ...additionalState
            })
        }, undefined, this.state.provenanceRequested)
    }

    /**
     * Re-fetches the reports with their provenance the first time Source view is opened. A no-op
     * afterwards: the flag is sticky, so the reports already carry it.
     */
    requestProvenance = () => {
        if (this.state.provenanceRequested) {
            return
        }
        this.setState({ provenanceRequested: true, provenanceLoading: true },
            () => this.reloadReports())
    }

    handleSourceViewToggle = (enabled) => {
        if (enabled) {
            this.requestProvenance()
        }
        this.setState({ sourceViewEnabled: enabled })
    }

    syncReportsWithModel() {
        const closeModal = () => this.setState({ syncReportsModal: null })
        this.setState({
            syncReportsModal: <BatchUpdateModal
                companyId={this.props.companyId}
                schemaId={this.props.schema.id}
                descriptors={this.props.schema.descriptors}
                reports={this.state.reports}
                closeModal={closeModal}
                onSaved={() => {
                    this.reloadReports()
                    closeModal()
                }} />
        })
    }

    syncReportsWithResourcesModel() {

        const closeModal = () => this.setState({ syncReportsModal: null })
        this.setState({
            syncReportsModal: <SyncWithResurcesModal
                flatDescriptors={this.flatDescriptors}
                companyId={this.props.companyId}
                schemaId={this.props.schema.id}
                closeModal={closeModal}
                onCreate={() => {
                    this.reloadReports()
                    closeModal()
                }} />
        })
    }

    openImportDataFromImageModal() {
        const schema = this.props.schema
        const closeModal = () => this.setState({ syncReportsModal: null })
        this.setState({
            syncReportsModal: <ImportDataFromImageModal
                companyId={this.props.companyId}
                schemaId={schema.id}
                closeModal={closeModal}
                schemaName={schema.name}
                schemaType={schema.type}
            />
        })
    }

    toggleAdvancedSettings = () => {
        this.setState({ filterCfg: { ...this.state.filterCfg, [ConfigProps.SHOW_ADVANCED_SETTINGS]: !this.state.filterCfg[ConfigProps.SHOW_ADVANCED_SETTINGS] } })
    }

    /**
     * 
     * @param {Object} settings Required Object containing the advancedTableCfg props and values
     */
    onAdvancedTableCfgChange = settings => {
        UserPreferences.save("tableConfig", settings)
        this.reloadReports({ advancedTableCfg: settings });
    }

    onProfileChange = (profile) => {
        UserPreferences.updateProfile(profile);
        this.setState({ profile, filterCfg: UserPreferences.get(UserPreferences.FILTER_CFG_PROP), advancedTableCfg: UserPreferences.get(UserPreferences.TABLE_CFG_PROP) })
    }

    onProfileReset = () => {
        UserPreferences.resetProfile();
        this.setState({filterCfg: UserPreferences.get(UserPreferences.FILTER_CFG_PROP), advancedTableCfg: UserPreferences.get(UserPreferences.TABLE_CFG_PROP)})
    }

    flipSign = (descriptorId) => {
        const reports = this.state.reports;
        const schemaId = this.props.schema.id
        const reportsEntities = getReportsEntries(reports, this.descriptors);
        flipReportsFieldValue(reportsEntities, descriptorId);
        const reportsChanges = getReportsChanges(reportsEntities);

        const closeModal = () => this.setState({ syncReportsModal: null });

        const save = (onComplete) => {
            const reportById = new Map(reports.map((r) => [r[ReportField.ID], r]));
            const reportsToUpdate = reportsEntities.map(({ reportMetadata, entities }) => {
                const report = reportById.get(reportMetadata.reportId);
                return ReportUtils.cellEntitiesToReport(entities, report);
            });

            function saveReport(reportsToSave, idx, schemaId, onComplete) {
                if (reportsToSave[idx] !== undefined) {
                    ReportsRepo.update(Object.assign({ schemaId }, reportsToSave[idx]), () => {
                        saveReport(reportsToSave, ++idx, schemaId, onComplete);
                    });
                } else {
                    onComplete();
                }
            }
            saveReport(reportsToUpdate, 0, schemaId, () => {
                this.reloadReports();
                closeModal();
                onComplete();
            });
        };
        this.setState({
            syncReportsModal: (
                <ReportsChangesConfirmationModal
                    data={getReportsChangesTableModel(reportsChanges)}
                    onConfirm={save}
                    targetedDescriptorId={descriptorId}
                    onCancel={closeModal}
                />
            ),
        });
    };

    content() {
        const filterCfg = this.state.filterCfg
        const schema = this.props.schema
        const readOnly = this.props.readOnly
        const reports = ReportsUtils.sort(applyFilterCfg(this.state.reports.concat(this.calculatedReports),
            filterCfg, this.state.advancedTableCfg, this.dynamicFlatDescriptors),
            filterCfg[ConfigProps.REPORTS_ORDER] === PropValues.DESC).map(report => {
                report.hash = hash(report)
                return report
            })
        return <>
            <Form size="mini">
                <FilterAndSortCfgV2 config={filterCfg}
                    advancedConfig={this.state.advancedTableCfg}
                    onAdvancedChange={advancedTableCfg => this.onAdvancedTableCfgChange(advancedTableCfg)}
                    onChange={filterCfg => {
                        const newFilterCfg = {...filterCfg,
                            [ConfigProps.ORIGINAL_VERSION_CONDITIONAL_FILTER]: ConfigProps.CONDITIONAL_ORIGINAL_DISABLED
                        }
                        this.setState({ filterCfg: newFilterCfg })
                        UserPreferences.save(UserPreferences.FILTER_CFG_PROP, newFilterCfg)
                    }} granularPeriodsFiltering={this.state.advancedTableCfg[ConfigProps.GRANULAR_PERIODS_FILTERING]}/>
                {filterCfg[ConfigProps.SHOW_ADVANCED_SETTINGS] && <TableAndP2pConfigV2 tableConfig={this.state.advancedTableCfg}
                    onTableConfigChange={advancedTableCfg => this.onAdvancedTableCfgChange(advancedTableCfg)}
                />}
                <Segment className='fillerOnlySettings'>
                    <Grid divided stackable>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                <div className='flex flex-align-center h-100'>
                                    <div className='table-config-segment'>
                                        <div className='config-module'>
                                            <CheckboxBtn
                                                checked={this.state.showFieldsSettings}
                                                label="Show Fields Settings"
                                                onChange={(checked) =>
                                                    this.setState({ showFieldsSettings: checked })
                                                } />
                                        </div>
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={3}>
                                <div className='flex flex-align-center h-100'>
                                    <div className='tableConfigSegment '>
                                        <div className='configModule'>
                                            <PasteMode />
                                        </div>
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={3}>
                                <div className="flex flex-align-center h-100">
                                    <div className="table-config-segment">
                                        <div className="config-module">
                                            {isSourceViewAvailable() && (
                                                <SourceViewToggle
                                                    className="checkboxBtn checked"
                                                    enabled={this.state.sourceViewEnabled}
                                                    onChange={this.handleSourceViewToggle}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={3}>
                                <div className="flex flex-align-center h-100">
                                    <div className="table-config-segment">
                                        <div className="config-module">
                                            <AcceptLabelConversionsButton
                                                className="checkboxBtn checked"
                                                getReports={() => ReportsUtils.sort(
                                                    applyFilterCfg(this.state.reports.concat(this.calculatedReports),
                                                        filterCfg, this.state.advancedTableCfg, this.dynamicFlatDescriptors, true),
                                                    filterCfg[ConfigProps.REPORTS_ORDER] === PropValues.DESC
                                                )}
                                                descriptors={this.descriptors}
                                                schemaId={schema.id}
                                                schemaName={schema.name}
                                                readOnly={readOnly}
                                                onChange={this.reloadReports}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <Segment className='table-actions-container-wrapper filler-view-actions-container' basic size='mini'>
                                    <div className='flex profile-settings-container tableConfigSegment '>
                                        <div className='configModule'>
                                        <SelectField
                                            className='profile-select'
                                            opsKV={Object.values(SETTINGS_PROFILE).map(pO => KeyValue.createSame(pO))}
                                            val={this.state.profile}
                                            onChange={(v) => this.onProfileChange(v)}
                                            />
                                            </div>
                                        <TableActionButton onClick={this.onProfileReset} className='reset-profile-button'>
                                            <Icon name="redo" />
                                        </TableActionButton>
                                    </div>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Form>
            {this.state.syncReportsModal}
            <ReportedAsLabelWarning reports={this.state.reports} descriptors={schema.descriptors} />
                <Table reports={reports}
                    sourceViewEnabled={this.state.sourceViewEnabled}
                    provenanceLoading={this.state.provenanceLoading}
                    standardizedLabels={this.state.standardizedLabels}
                    descriptors={this.descriptors}
                    schemaId={schema.id}
                    schemaName={schema.name}
                    onChange={this.reloadReports}
                    getCopyTargets={srcReport => getAvalableTargetReports(srcReport, this.state.reports, schema.name)}
                    setDirty={this.props.setDirty}
                    flipSign={this.flipSign}
                    //TODO backend protection
                    readOnly={readOnly}
                    companyId={this.props.companyId}
                    showFieldsSettings={this.state.showFieldsSettings}
                    flatDescriptors={this.flatDescriptors}
                    advancedTableCfg={this.state.advancedTableCfg}
                    filterCfg={filterCfg} />
                {this.state.advancedTableCfg[ConfigProps.SHOW_CHARTS] && <Segment>
                    <TableChart
                        schemaId={schema.id}
                        schemaName={schema.name}
                        companyId={this.props.companyId}
                        companyName={this.props.companyName}
                        ticker={this.props.companyTicker}
                        companyTitle={this.props.companyTitle}
                        descriptors={this.dynamicFlatDescriptors}
                        reports={reports}
                        descending={filterCfg[ConfigProps.REPORTS_ORDER] === PropValues.DESC}
                    />
                </Segment>}
                {!readOnly && <div style={{position:"relative"}} className='reports-table-bottom-ops'>
                    <Button size='mini'
                        onClick={() => this.syncReportsWithModel()}>Sync With Model
                    </Button >
                    <Button size='mini'
                        onClick={() => this.syncReportsWithResourcesModel()}>Sync With Resources
                    </Button >
                    <ImportFromImageButton onClick={() => this.openImportDataFromImageModal()} />
                    <ActiveImports schemaId={schema.id} />
                </div >}
            <div className='currencyInfo'>Currency: <b>{this.props.currency}</b></div>
            <Legend/>
        </>
    }

    render() {
        return this.state.loading === true ? <Loader /> : this.content()
    }
}


export default Reports
